import React from "react";
import { useState } from "react";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import { Link } from 'react-router-dom';

//import axios from 'axios';
import axios_api from "../Api";

import { API_URL, AUTH_TOKEN } from '../Context';





function SystemTicket({ticket}) {
  //console.log(ticket);

  let followUps = [];
  for (let i in ticket.follow_ups) {
    //console.log(ticket.follow_ups[i])

    let attachments = []
    for (let j in ticket.follow_ups[i].attachments) {

      attachments.push(<p className="m-0"><a href={ticket.follow_ups[i].attachments[j].file} >вложение {+j + 1}</a></p>)
    }



    followUps.push(
      <>
        <p>{ticket.follow_ups[i].date} - {ticket.follow_ups[i].title}</p>
        <div className="m-3">{attachments}</div>
        
      </>
    );                           
  }

  return(
    <div className="m-3">
      <h6 className="mt-4 mb-3">{ticket.created} - {ticket.title}</h6>
      {followUps}
    </div> 
  )
}


function YearHistory({year}){

  console.log(year)

  let system_tickets = [];
  for (let i in year.system_tickets) {
    system_tickets.push(
      <SystemTicket
        key={year.system_tickets[i].id}
        ticket={year.system_tickets[i]}
      />
    );      
    //console.log(year.system_tickets[i])   
  }

  let user_tickets = [];
  for (let i in year.user_tickets) {
    user_tickets.push(
      <p><Link to={`/ticket/` + year.user_tickets[i].id }>Обращение № {year.user_tickets[i].id}</Link></p>
    );                           
  }

  return(
    <div className="card lk-border my-5">
      <div className="card-header text-center">
        <h4 className="m-2">{year.year} год</h4>
      </div>
      <div className="card-body m-5">  
        <div className="mb-5">
          <h4>Заказ</h4>
          {year.order ?
              <Link className="m-3" to={`/order/` + year.order.id }>Заказ № {year.order.user.username}-{year.year}</Link>       
            : 
              <p className="m-3">отсутствует</p> 
          }
        </div>
        <div className="mb-5">
          <h4>Действия</h4>
          
          {system_tickets.length > 0 ?
              system_tickets
            : 
              <p className="m-3">отсутствуют</p> 
          }
        </div>
        <div className="">
          <h4>Обращения</h4>
          <div className="m-3">
          {user_tickets.length > 0 ?
              user_tickets
            : 
              <p className="m-3">отсутствуют</p> 
          }
          </div>
        </div>
      </div> 
    </div> 
  )
}


export default function Lab({}) {
  const [labHistory, setLabHistory] = useState([]);
  // const [groups, setGroups] = useState([]);
  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);

  let { labId } = useParams();


  React.useEffect(() => {

    let lab = axios_api.get(api_url + '/history/' + labId, {
      headers: {"Authorization": token},
    });

    lab.then(
      (result) => {
        let apiReturnedLab = result.data;
        setLabHistory(apiReturnedLab);
        console.log(apiReturnedLab)
      },
      (error) => {
        console.log(error)
        setLabHistory([]);
      }
    );

  }, []);

  let rows = [];
  for(let year in labHistory) {

    if (labHistory[year].order || labHistory[year].system_tickets.length > 0 || labHistory[year].user_tickets.length > 0) {
      rows.push(
        <YearHistory
          key={labHistory[year].year}
          year={labHistory[year]}
        />
      );
    }
  }

  let labHasHistory = false;
  rows.length > 0 ? labHasHistory = true : labHasHistory = false;

  return (
    <>
      <div className="row">
        <div className="col-9 m-3">
          <h3 className="">История лаборатории № {labId}</h3>
          {labHasHistory ?
              <>
                {rows}
              </>
            :
              <p className="mt-5">У этой лаборатории пока нет истории</p>
          }
        </div> 
      </div> 
    </>
  )
}